import * as urlUtils from 'utils/Url';
import constants from 'Constants';
import { getAuth, patchAuth, postAuth, deleteAuth } from 'api/Utils';


function pathViewShopifySettingsShforms() {
  return `view/shopify-settings-shforms`;
}

export function getViewShopifySettingsShforms(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(pathViewShopifySettingsShforms(), qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

function pathUpdateShopifySubscriptions(subscriptionId=null) {
  if (subscriptionId) {
      return `shopify-billing/subscriptions/${subscriptionId}/update`;
  } else {
      return `shopify-billing/subscriptions/update`;
  }
}

export function postUpdateShopifySubscriptions(successCallback, errorCallback, data, subscriptionId=null) {
  postAuth({
    "path": pathUpdateShopifySubscriptions(subscriptionId),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function postCancelShopifySubscriptions(successCallback, errorCallback, subscriptionId) {
  postAuth({
    "path": `shopify-billing/subscriptions/${subscriptionId}/cancel`,
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function postResumeShopifySubscriptions(successCallback, errorCallback, subscriptionId) {
  postAuth({
    "path": `shopify-billing/subscriptions/${subscriptionId}/resume`,
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}


function pathShopifySettings() {
  return `shopify-settings`;
}

export function patchShopifySettings(successCallback, errorCallback, data) {
  patchAuth({
    "path": pathShopifySettings(),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function syncShopifyProductMetafields(successCallback, errorCallback) {
  postAuth({
    "path": `sync-shopify-product-metafields`,
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function syncShopifyBackInStockMetafields(successCallback, errorCallback) {
  postAuth({
    "path": `sync-shopify-back-in-stock-metafields`,
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}
